import { render, staticRenderFns } from "./internal.vue?vue&type=template&id=9013b166"
import script from "./internal.vue?vue&type=script&lang=js"
export * from "./internal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Preview: require('/home/ubuntu/containers/hermes_eshop/components/core/preview.vue').default,ScssInit: require('/home/ubuntu/containers/hermes_eshop/components/core/scssInit.vue').default,DesignSystem: require('/home/ubuntu/containers/hermes_eshop/components/core/designSystem.vue').default,Cookies: require('/home/ubuntu/containers/hermes_eshop/components/core/cookies.vue').default,Specific: require('/home/ubuntu/containers/hermes_eshop/components/core/specific.vue').default})
